import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import LoadingSpinner from '../components/LoadingSpinner';
import './Login.css';

const Register = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    nombreCompleto: '',
    telefono: '',
    tipoUsuario: 'FOTOGRAFO',
    nombreEmpresa: '',
    numeroIdentificacion: '',
    tipoSuscripcion: 'BASICA',
    numeroCompetidor: '',
    whatsappNumero: ''
  });

  
  const [confirmarPassword, setConfirmarPassword] = useState('');
  const [aceptaTerminos, setAceptaTerminos] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    if (formData.password !== confirmarPassword) {
      setError('Las contraseñas no coinciden');
      setLoading(false);
      return;
    }

    if (!aceptaTerminos) {
      setError('Debes aceptar los Términos de Uso y Aviso de Privacidad para continuar');
      setLoading(false);
      return;
    }

    try {
      await register({ ...formData, aceptaTerminos });
      alert('Registro exitoso. Por favor inicia sesión.');
      navigate('/login');
    } catch (err) {
      setError(err.response?.data?.message || 'Error al registrarse');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      {loading && <LoadingSpinner mensaje="Creando cuenta..." />}
      <div className="auth-card">
        <h2>Registro</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email *</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="correo@ejemplo.com"
            />
          </div>

          <div className="form-group">
            <label>Contraseña *</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              minLength={6}
              placeholder="Mínimo 6 caracteres"
            />
          </div>

          <div className="form-group">
            <label>Confirmar Contraseña *</label>
            <input
              type="password"
              value={confirmarPassword}
              onChange={(e) => setConfirmarPassword(e.target.value)}
              required
              minLength={6}
              placeholder="Repite tu contraseña"
            />
          </div>

          <div className="form-group">
            <label>Nombre Completo *</label>
            <input
              type="text"
              name="nombreCompleto"
              value={formData.nombreCompleto}
              onChange={handleChange}
              required
              placeholder="Tu nombre"
            />
          </div>

          <div className="form-group" style={{display:'flex', alignItems:'flex-start', gap:'10px', marginTop:'8px'}}>
            <input
              type="checkbox"
              id="aceptaTerminos"
              checked={aceptaTerminos}
              onChange={(e) => setAceptaTerminos(e.target.checked)}
              style={{marginTop:'3px', cursor:'pointer', flexShrink:0}}
            />
            <label htmlFor="aceptaTerminos" style={{fontWeight:'normal', cursor:'pointer', fontSize:'0.9rem', lineHeight:'1.4'}}>
              Acepto los{' '}
              <Link to="/terminos" target="_blank" rel="noopener noreferrer">Términos de Uso</Link>
              {' '}y el{' '}
              <Link to="/aviso-privacidad" target="_blank" rel="noopener noreferrer">Aviso de Privacidad</Link>
              {' '}de Xaltech Manufacturing Services SA de CV *
            </label>
          </div>

          {error && <div className="error">{error}</div>}

          <button type="submit" className="button" disabled={loading || !aceptaTerminos}>
            {loading ? 'Registrando...' : 'Registrarse'}
          </button>
        </form>

        <p className="auth-footer">
          ¿Ya tienes cuenta? <Link to="/login">Inicia sesión aquí</Link>
        </p>
      </div>
    </div>
  );
};

export default Register;
